import ctl from '@netlify/classnames-template-literals'
import { MagicSwirl } from '../magic-swirl'

export function WidgetInputBox(
	{ children, isGenerating = false, className = '' }: {
		children: React.ReactNode
		isGenerating?: boolean
		className?: string
	},
) {
	return (
		<div className={ctl(`bg-grey-50/0 py-1.5 px-2 ring-1 ring-black/10 rounded relative ${className}`)}>
			{children}
			{isGenerating ? <MagicSwirl /> : null}
		</div>
	)
}
